
<template>
  <i
    v-if="isValidImageUrl(state.icons[name])"
    class="cxco-c-icon"
    :style="`background-size: contain; background-image: url(${state.icons[name]});`"
  >
  </i>
  <svg
    v-else
    class="cxco-c-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <title>{{ name }}</title>
    <path fill-rule="evenodd" :d="this[name]" />
  </svg>
</template>
<script>
import { inject } from "vue";
import { isValidImageUrl } from "../utils/index";

export default {
  setup() {
    const state = inject("state");
    const actions = inject("actions");
    return { state, actions };
  },
  data: function () {
    return {
      search:
        "M4,10 C4,6.691 6.691,4 10,4 C13.309,4 16,6.691 16,10 C16,13.309 13.309,16 10,16 C6.691,16 4,13.309 4,10 M21.707,20.293 L16.312,14.897 C17.365,13.543 18,11.846 18,10 C18,5.589 14.411,2 10,2 C5.589,2 2,5.589 2,10 C2,14.411 5.589,18 10,18 C11.846,18 13.543,17.365 14.897,16.312 L20.293,21.707 C20.488,21.902 20.744,22 21,22 C21.256,22 21.512,21.902 21.707,21.707 C22.098,21.316 22.098,20.684 21.707,20.293",
      error:
        "M16.707,15.293 C16.902,15.488 17,15.744 17,16 C17,16.256 16.902,16.512 16.707,16.707 C16.512,16.902 16.256,17 16,17 C15.744,17 15.488,16.902 15.293,16.707 L12,13.414 L8.707,16.707 C8.512,16.902 8.256,17 8,17 C7.744,17 7.488,16.902 7.293,16.707 C7.098,16.512 7,16.256 7,16 C7,15.744 7.098,15.488 7.293,15.293 L10.586,12 L7.293,8.707 C7.098,8.512 7,8.256 7,8 C7,7.744 7.098,7.488 7.293,7.293 C7.684,6.902 8.316,6.902 8.707,7.293 L12,10.586 L15.293,7.293 C15.684,6.902 16.316,6.902 16.707,7.293 C16.902,7.488 17,7.744 17,8 C17,8.256 16.902,8.512 16.707,8.707 L13.414,12 L16.707,15.293 Z M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.519,22 22,17.52 22,12 C22,6.48 17.519,2 12,2 L12,2 Z",
      success:
        "M9.00025,18.9995777 C8.73525,18.9995777 8.48025,18.8945777 8.29325,18.7065777 L3.29325,13.7065777 C2.90225,13.3155777 2.90225,12.6835777 3.29325,12.2925777 C3.68425,11.9015777 4.31625,11.9015777 4.70725,12.2925777 L8.96925,16.5535777 L19.26325,5.32357773 C19.63725,4.91757773 20.26825,4.88957773 20.67625,5.26257773 C21.08325,5.63557773 21.11025,6.26857773 20.73725,6.67557773 L9.73725,18.6755777 C9.55325,18.8765777 9.29425,18.9935777 9.02125,18.9995777 L9.00025,18.9995777 Z",
      toggle:
        "M12.00025,15.00025 C11.74425,15.00025 11.48825,14.90225 11.29325,14.70725 L6.29325,9.70725 C5.90225,9.31625 5.90225,8.68425 6.29325,8.29325 C6.68425,7.90225 7.31625,7.90225 7.70725,8.29325 L12.00025,12.58625 L16.29325,8.29325 C16.68425,7.90225 17.31625,7.90225 17.70725,8.29325 C18.09825,8.68425 18.09825,9.31625 17.70725,9.70725 L12.70725,14.70725 C12.51225,14.90225 12.25625,15.00025 12.00025,15.00025",
      close:
        "M13.4261944,11.9997479 L17.7050296,7.72091264 C17.9016765,7.52426573 18.0005042,7.26610362 18.0005042,7.00794151 C18.0005042,6.7497794 17.9016765,6.49262574 17.7050296,6.29497038 C17.3107273,5.90167654 16.6723812,5.90167654 16.2790874,6.29497038 L12.0002521,10.5738056 L7.72141687,6.29497038 C7.32812303,5.90167654 6.68977688,5.90167654 6.2954746,6.29497038 C6.09882768,6.49262574 6,6.7497794 6,7.00794151 C6,7.26610362 6.09882768,7.52426573 6.2954746,7.72091264 L10.5743098,11.9997479 L6.2954746,16.2785831 C6.09882768,16.4752301 6,16.7333922 6,16.9915543 C6,17.2497164 6.09882768,17.50687 6.2954746,17.7045254 C6.49312996,17.9011723 6.75028363,18 7.00844573,18 C7.26660784,18 7.52476995,17.9011723 7.72141687,17.7045254 L12.0002521,13.4256902 L16.2790874,17.7045254 C16.4757343,17.9011723 16.7338964,18 16.9920585,18 C17.2502206,18 17.5073743,17.9011723 17.7050296,17.7045254 C17.9016765,17.50687 18.0005042,17.2497164 18.0005042,16.9915543 C18.0005042,16.7333922 17.9016765,16.4752301 17.7050296,16.2785831 L13.4261944,11.9997479 Z",
    };
  },
  props: {
    name: String,
  },
  methods: {
    isValidImageUrl,
  },
};
</script>